import SearchIcon from 'assets/svg/search/search-abu.svg'
import AutoComplete from 'common/components/AutoComplete'
import Button from 'common/components/Button'
import apiClient from 'lib/api-client'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import theme from 'services/LocalStorefront/theme'
import styled from 'styled-components'

const WrapperSearch = styled.div`
  width: ${({ width }) => width};
  display: inline-flex;
`

interface SearchType {
  hideHelperText?: boolean
  placeholder?: string
  spacingSize?: string
  width?: string
}

function Search({
  hideHelperText = false,
  placeholder,
  spacingSize = '50px',
  width = '100%',
}: SearchType): JSX.Element {
  const router = useRouter()
  const [stores, setStores] = useState<
    Array<{
      value: number
      label: string
    }>
  >([])
  const [searchValue, setSearchValue] = useState<string>('')
  const [tempStore, setTempStore] = useState<string>('')
  const [fetchedStore] = useState({})
  const [onStoreLoad, setOnStoreLoad] = useState<boolean>(false)

  const getStore = async (e) => {
    try {
      const response = await apiClient({
        url: '/tokopos/v1/storefronts',
        method: 'GET',
        params: {
          store_name: e,
        },
      })
      if (response?.data?.data) {
        const tempStores = stores

        setStores([])
        response.data.data.forEach((store) => {
          if (!fetchedStore[store.id]) {
            fetchedStore[store.id] = store.storefront_url
            tempStores.push({
              value: store.id,
              label: store.store_name,
            })
          }
        })
        setStores(tempStores)
      }
    } catch (error) {
      // on error do something
    }
  }

  const handleSelect = (value) => {
    window.open(`${fetchedStore[value]}?utm_source=ralali`, '_blank')
  }
  const submit = (e) => {
    e.preventDefault()
    if (tempStore && tempStore.length >= 3) {
      router.push({
        pathname: '/local-store/search',
        query: { q: tempStore },
      })
      setOnStoreLoad(true)
    }
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      if (tempStore.length >= 3) {
        getStore(tempStore)
      }
    }, 500)

    return () => clearTimeout(timer)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tempStore])

  useEffect(() => {
    setOnStoreLoad(false)
  }, [router.query])

  return (
    <form onSubmit={submit}>
      <WrapperSearch width={width}>
        {!onStoreLoad && (
          <AutoComplete
            hideHelperText={hideHelperText}
            onHoverColor="primaryKonekto"
            onSelect={handleSelect}
            options={stores}
            padding="12px"
            placeholder={placeholder}
            value={searchValue}
            onTyping={setTempStore}
            onChange={(val) => setSearchValue(val)}
            width={width}
            withIcon={{ position: 'left', icon: <SearchIcon /> }}
            minLength="3"
            borderActiveColor={theme.primaryKonekto}
          />
        )}
      </WrapperSearch>
      <Button
        type="submit"
        letterCase="capitalize"
        color="primaryKonekto"
        margin={`0 0 0 ${spacingSize}`}
        padding="0 50px"
      >
        cari
      </Button>
    </form>
  )
}

export default Search
